export const appointmentStatus = (rowData: any) => {
   
    const moldeName = rowData?.metadata?.molde && rowData?.metadata?.molde?.name?.toLowerCase();
    const moldePlantProfessional = moldeName?.includes('medico en planta') && rowData?.status === "Presente en Lavoris";
    if (moldePlantProfessional) return 'Control en planta';

    if (rowData.status === "Presente en Lavoris" && rowData?.metadata?.practices?.some((practice: any) => practice?.name?.includes('Telemedicina'))) {
        return "Telemedicina"
    }
    if (rowData.status === "Ausente" && rowData?.metadata?.practices?.some((practice: any) => practice?.name?.includes('Telemedicina'))) {
        return "No atendió llamado"
    }
    else {
        return rowData.status
    }

}